<section-panel
  class="section"
  [paddings]="paddings || 'none'"
  [borderless]="borderless || true"
  [disabled]="disabled"
>
  <div class="header" [ngClass]="{ 'hideHeader': hideHeader }">
    <ion-icon
      [@toggleArrow]="{ value: arrowState }"
      size="medium"
      src="assets/dropdown_arrow.svg"
      class="arrow"
      (click)="onToggle()"
    ></ion-icon>
    <span class="label">{{title}}</span>
    <span class="label-note" *ngIf="titleNote">{{titleNote}}</span>
  </div>

  <ion-accordion-group #accordionGroup [value]="arrowState">
    <ion-accordion value="collapsed" toggleIcon="">
      <ion-item slot="header"></ion-item>
      <div class="expander" slot="content" [ngClass]="{ 'expander_padding': !!collapsedContent }" [@contentFade]="collapsedFadeState">
        <ng-container *ngTemplateOutlet="collapsedContent"></ng-container>
      </div>
    </ion-accordion>

    <ion-accordion value="expanded" toggleIcon="">
      <ion-item slot="header"></ion-item>
      <div class="expander expander_padding" slot="content" [@contentFade]="expandedFadeState">
        <ng-content></ng-content>
      </div>
    </ion-accordion>
  </ion-accordion-group>
  <div #anchor> </div>
</section-panel>
